import type { ReactNode } from "react";

export interface PropCompoTitle{
  children?:ReactNode
}

export default function CompoTitle(prop:PropCompoTitle) {
  return (<>
    <div className="
      text-[1.1rem] font-bold 
    ">
      {prop.children}
    </div>
    <div className="border-b border-zinc-300 mt-2" />
  </>);
}
